import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/images/play-btn.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-8b04bd74"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "question-detail aio-question-detail",
  "talqs-app": ""
}
const _hoisted_2 = { class: "m-que-section" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-section-title" }, "题目解析", -1))
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  key: 0,
  class: "m-que-section"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-section-title" }, "视频讲解", -1))
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "video-btn"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "u-full-width-seperator" }, null, -1))
const _hoisted_10 = { class: "m-que-section m-answer-section" }
const _hoisted_11 = { class: "m-answer-detail" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-answer-label" }, "正确答案", -1))
const _hoisted_13 = { class: "m-answer-desc success" }
const _hoisted_14 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "m-section-content question-title",
        id: `questionAnalysis_${$props.questionIndex}`
      }, null, 8, _hoisted_4)
    ]),
    ($setup.playVideoParam?.content_id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", {
            class: "m-section-content relate-video",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.doPlayVideo && $setup.doPlayVideo(...args)))
          }, [
            ($setup.videoImg)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: $setup.videoImg,
                  alt: "",
                  class: "video-img"
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            _hoisted_8
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            class: "m-section-content question-answer",
            id: `questionAnswer_${$props.questionIndex}`
          }, null, 8, _hoisted_14)
        ])
      ])
    ])
  ]))
}